export const link = {
  link: {
    shape:
      '<path d="M11.544 8.456a4.368 4.368 0 0 0-6.176 0L2.28 11.544a4.368 4.368 0 1 0 6.177 6.177L10 16.177M8.457 11.544a4.368 4.368 0 0 0 6.176 0l3.089-3.088a4.367 4.367 0 1 0-6.177-6.177l-1.544 1.544" stroke="#333" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>',
    viewBox: [0, 0, 21, 20],
  },
};
